type CurrencyType = '₹' | '$' | '€'

export const currency: CurrencyType = '$'

export const currentYear = new Date().getFullYear()

export const credits = {
  website: 'https://coderthemes.com/',
  name: 'Coderthemes',
  buyLink: '',
}

export const basePath: string = '/'
